module.exports = __webpack_public_path__ + "img/image_offline01@2x.9792f799.png";